// extracted by mini-css-extract-plugin
export default {"CheckboxComponent":"Switch_CheckboxComponent__VKERw"};